import React from 'react';
import IconWithPrimarySecondaryLabel from 'PointOfSale/modules/layouts/component/servingOptions/IconWithPrimarySecondaryLabel';
import { Dropdown } from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { SessionTypeDetails } from 'PointOfSale/modules/common/constants';

const SessionDropDownItems = ({
  sessions,
  activeSession,
  onSessionClick,
  onSessionAdd,
}) => (
  <React.Fragment>
    {_.map(sessions, (item, key) =>
      activeSession !== key ? (
        <Dropdown.Item
          value={key}
          id={key}
          key={key}
          className="borderNone borderBottomWithGray"
          onClick={() => onSessionClick({ key, data: item })}
        >
          <span className="sessionDropDownItem">
            {SessionTypeDetails[key].label}
          </span>
        </Dropdown.Item>
      ) : null
    )}
    <Dropdown.Item
      key="dropDownItemSession"
      className="menuNotSelected borderNone"
      value={'AddSession'}
      onClick={onSessionAdd}
    >
      <IconWithPrimarySecondaryLabel
        key="addSessionIconKey"
        IconWidth={'30%'}
        icon={'plus circle'}
        textWidth={'70%'}
        primaryLabel={'Add'}
        secondaryLabel={'Session'}
        IconClassName={'sessionDropDownItem iconCss'}
        labelClassName={'sessionDropDownItem'}
      />
    </Dropdown.Item>
  </React.Fragment>
);

SessionDropDownItems.propTypes = {
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  onSessionClick: PropTypes.func,
};
export default SessionDropDownItems;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/SessionDropDownItems.js